module.exports = __webpack_public_path__ + "img/header_b-drive_1192x282.45a6de56.jpg";